import angular from 'angular';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';
import { CommonsUserUtilsService } from 'ib-web-commons/dist/utils/ib-commons-user-utils.service';

const componentOptions = {
    bindings: {
        totalPrice: '=',
        continueText: '='
    },
    controllerAs: 'brkdownAnciCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-breakdown-ancillaries-view.html';
    }]
};


const componentInfo = {
    module: 'ib-breakdown-ancillaries-module',
    selector: 'ibBreakdownAncillaries',
    inject: ['$scope', '$rootScope', 'localStorageService', '$sce', 'AncillariesUtilsService', '$timeout', '$window', 'CommonsUserUtilsService'],
    required: []
};

export class ibBreakdownAncillaries implements ng.IController {
    public relatedContent;
    public aviosToEarn;
    public elitePointsToEarn;
    public flightAviosInfo: boolean;
    public isCubaInsuranceModalShown: boolean;
    public isIbZero: boolean;
    public isRedemptionBKI: boolean = false;
    public aviosPrice: number;
    constructor (
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private $sce: any,
        private AncillariesUtilsService: AncillariesUtilsService,
        private $timeout: ng.ITimeoutService,
        private window: ng.IWindowService,
        private CommonsUserUtilsService: CommonsUserUtilsService
    ) {
        const getAviosAndElitePointsEvent = this.$scope.$on( 'updateAvios', this.getAviosAndElitePoints );
        const nextStepFlowListener = () => {
            this.cleanTransfersGlobick();
            this.goPayment();
        };
        this.$scope.$on( '$destroy', () => {
            getAviosAndElitePointsEvent;
            this.window.removeEventListener( 'nextStepFlowLegacy', nextStepFlowListener );
        } );
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
        this.window.addEventListener( 'nextStepFlowLegacy', nextStepFlowListener );
        this.isIbZero = this.CommonsUserUtilsService.isIbZero();
    }

    $onInit (): void {
        this.getRelatedContent();
        if (this.$rootScope.flowName === 'BKI' && this.$rootScope.appMarket === 'ES') {
            const country:any = this.localStorageService.get('headerModel');
            this.isCubaInsuranceModalShown = country.headerModel.trips[0].destinyCode !== 'HAV' && country.headerModel.trips[0].originCode !== 'HAV';
        } else {
            this.isCubaInsuranceModalShown = true;
        }
        this.checkRedemptionBKI();
    }

    checkRedemptionBKI = (): void => {
        if (this.$rootScope.isRedemptionFlow && this.$rootScope.flowName === 'BKI') {
            const redemptionFareData: any = this.localStorageService.get('selectedFareRedemptionData');
            this.aviosPrice = redemptionFareData.price.totalAvios;
            this.isRedemptionBKI = true;
        }
    };

    cleanTransfersGlobick = (): void => {
        this.$rootScope.$broadcast('setDisconfirmed');
        this.$scope.$emit('goPaymentTransfers');
    };

    goPayment = (): void => {
        const headerModel:any = this.localStorageService.get('headerModel');
        if(headerModel.shoppingBasket) {
            if (!this.isCubaInsuranceModalShown && !headerModel.shoppingBasket.insurance.hasInsurance) {
                this.$scope.$emit('openInsuranceInfoCubaModal');
                this.isCubaInsuranceModalShown = true;
            }else if(!this.isCubaInsuranceModalShown && headerModel.shoppingBasket.insurance.hasInsurance) {
                if (!headerModel.shoppingBasket.insurance.info.offer.includes('COM025')) {
                    this.$scope.$emit('openInsuranceInfoCubaModal');
                    this.isCubaInsuranceModalShown = true;
                }else {
                    this.$scope.$emit('goToPayments');
                }
            }else {
                this.$scope.$emit('goToPayments');
            }
        } else if(!this.isCubaInsuranceModalShown && !headerModel.shoppingBasket) {
            this.$scope.$emit('openInsuranceInfoCubaModal');
            this.isCubaInsuranceModalShown = true;
        } else {
            this.$scope.$emit('goToPayments');
        }
    };

    /**
     * Get relatedContent from localStorageService to show in BBKI flow
     */
    getRelatedContent = (): void => {
        const relatedContent = this.localStorageService.get('availabilityRelatedContent');
        if (relatedContent) {
            angular.forEach(relatedContent, (content) => {
                if (content.key === 'TOTAL_PRICE') {
                    this.relatedContent = this.createObjRelatedContent(content);
                    this.getAviosAndElitePoints();
                }
            });
        }
    };

    /**
     * Get Avios and Elite Points from localStorageService to show in BBKI flow
     */
    getAviosAndElitePoints = (): void => {
        const pointsData: any = this.localStorageService.get('CalculatedPoints');
        this.aviosToEarn = pointsData ? pointsData.Avios : 0;
        this.elitePointsToEarn = pointsData ? pointsData.Elite : 0;
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
    };

    /**
   * Return Object with all information about related content return in order service
   * @param {*} relatedContent
   */
    createObjRelatedContent =(relatedContent):any=> {
        let returnedRelatedContent:any = {};
        if (relatedContent.key === 'TOTAL_PRICE') {
            returnedRelatedContent = { original: { totalPriceText: relatedContent.value ? relatedContent.value : null }, transformed: {} };
            if (relatedContent.value) {
                returnedRelatedContent.transformed.TOTAL_PRICE = this.$sce.trustAsHtml(relatedContent.value);
            }
        }
        return returnedRelatedContent;
    };
}



try {
    const mod = angular.module(componentInfo.module);
    ibBreakdownAncillaries.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBreakdownAncillaries })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBreakdownAncillaries.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBreakdownAncillaries })
    );
}